// extracted by mini-css-extract-plugin
export default {"status_container":"CustomizableServices_status_container__fEuva","status":"CustomizableServices_status__t+Dwi"};